import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: 'glxy-page-actions, [glxyPageActions]',
  standalone: false,
})
export class PageActionsDirective {
  @HostBinding('class') class = 'glxy-page-actions';
}
